import { useI18n } from '../contexts/I18nContext';
import { CircularTestimonials } from '../components/ui/circular-testimonials';

export default function CoreFeaturesSection() {
  const { t, isRTL } = useI18n();

  // Unsplash images for each feature
  const featureImages = [
    'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&q=80', // Smart matching
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80', // Dashboard
    'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&q=80', // Consultation
    'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=80', // Community
    'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80', // Regulations
    'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&q=80', // Scholarships
    'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600&q=80', // Generator
    'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&q=80', // Analytics
  ];

  const featuresAsTestimonials = t.coreFeatures.features.map((feature, index) => ({
    quote: feature.description,
    name: feature.title,
    designation: "EduNasser Feature",
    src: featureImages[index],
  }));

  return (
    <section className="py-20 bg-gradient-to-br from-white via-[#F8F5FF] to-white relative overflow-hidden" id="services">
      {/* Hero Image Background */}
      <div className="absolute inset-0 opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1920&q=80" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>

      {/* Creative geometric shapes background */}
      <div className={`absolute top-10 ${isRTL ? 'left-10' : 'right-10'} w-32 h-32 border-4 border-[#9FFFCB] rounded-full opacity-20`}></div>
      <div className={`absolute top-40 ${isRTL ? 'right-20' : 'left-20'} w-24 h-24 border-4 border-[#B18AE0] rotate-45 opacity-20`}></div>
      <div className={`absolute bottom-20 ${isRTL ? 'left-1/4' : 'right-1/4'} w-40 h-40 border-4 border-[#5B3FD0] rounded-full opacity-10`}></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 animate-fade-in-up">
          <div className="inline-block mb-4">
            <div className="flex items-center gap-2 px-6 py-2 border-2 border-[#9FFFCB] rounded-full bg-white/80 backdrop-blur-sm">
              <div className="w-2 h-2 bg-[#9FFFCB] rounded-full animate-pulse"></div>
              <span className="text-sm font-bold text-[#5B3FD0] uppercase tracking-wider">Core Features</span>
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-6">
            {t.coreFeatures.title}
          </h2>
          <p className="text-lg text-[#707070] leading-relaxed">
            {t.coreFeatures.intro}
          </p>
        </div>

        {/* Features carousel */}
        <div className="flex flex-wrap items-center justify-center relative w-full">
          <CircularTestimonials
            testimonials={featuresAsTestimonials}
            autoplay={true}
            colors={{
              name: "#2C2C2C",
              designation: "#B18AE0",
              testimony: "#606060",
              arrowBackground: "#5B3FD0",
              arrowForeground: "#ffffff",
              arrowHoverBackground: "#4729b0",
            }}
            fontSizes={{
              name: "32px",
              designation: "18px",
              quote: "22px",
            }}
          />
        </div>
      </div>
    </section>
  );
}
